import {Component, Injector} from '@angular/core';
import {WidgetDataControllerComponent} from '../../../../Controller/widget-data-controller-component';
import {TasksReportsApiService} from '../../../../../Services/Api/Reports/Tasks/tasks-reports-api.service';
import {AuditReportDto} from '../../../../../Models/Reports/Tasks/Audit/audit-report.interface';
import {ApiResponse} from '../../../../../Services/Api/base-api.service';
import {TasksReportFilters} from '../../../../../Models/Reports/Tasks/Shared/tasks-report-filters.model';

@Component({
  selector: 'app-completed-audit-widget',
  templateUrl: './completed-audit-widget.component.html',
  styleUrls: ['./completed-audit-widget.component.scss'],
  standalone: false
})
export class CompletedAuditWidgetComponent extends WidgetDataControllerComponent<number> {

  override fakeData: number = 82;

  get widgetData(): number {
    return this.data || this.data === 0 ? this.data : this.fakeData;
  }

  constructor(
    protected override injector: Injector,
    protected tasksReportsService: TasksReportsApiService,
  ) {
    super(injector, tasksReportsService);
  }


  /**
   * Obtener el porcentaje de auditorías completadas
   *
   */
  override setData(data: AuditReportDto) {
    this.data = data ? Math.round(data.porcentaje_global.base) : 0;
  }


  /**
   * Obtener datos
   *
   */
  getData(): Promise<ApiResponse> {
    const filters: TasksReportFilters = new TasksReportFilters();

    if (this.widgetsManager.filters) {
      filters.id_local = this.widgetsManager.filters.local?.id ? [this.widgetsManager.filters.local.id] : [];
      filters.fecha_inicio = this.widgetsManager.filters.fecha_inicio || filters.fecha_inicio;
      filters.fecha_fin = this.widgetsManager.filters.fecha_fin || filters.fecha_fin;
    }

    return this.tasksReportsService.getAuditsReport(filters);
  }

}
